"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanetTypeNames = exports.RarityNames = exports.ArtifactNames = exports.BiomeNames = exports.Biome = exports.SpaceType = void 0;
/**
 * enum for the types of space in the game. NEBULA = 0, DEAD_SPACE = 3
 */
var SpaceType;
(function (SpaceType) {
    SpaceType[SpaceType["NEBULA"] = 0] = "NEBULA";
    SpaceType[SpaceType["SPACE"] = 1] = "SPACE";
    SpaceType[SpaceType["DEEP_SPACE"] = 2] = "DEEP_SPACE";
    SpaceType[SpaceType["DEAD_SPACE"] = 3] = "DEAD_SPACE";
})(SpaceType = exports.SpaceType || (exports.SpaceType = {}));
/**
 * enum for the biomes in the game. OCEAN = 1, CORRUPTED = 10
 */
var Biome;
(function (Biome) {
    Biome[Biome["UNKNOWN"] = 0] = "UNKNOWN";
    Biome[Biome["OCEAN"] = 1] = "OCEAN";
    Biome[Biome["FOREST"] = 2] = "FOREST";
    Biome[Biome["GRASSLAND"] = 3] = "GRASSLAND";
    Biome[Biome["TUNDRA"] = 4] = "TUNDRA";
    Biome[Biome["SWAMP"] = 5] = "SWAMP";
    Biome[Biome["DESERT"] = 6] = "DESERT";
    Biome[Biome["ICE"] = 7] = "ICE";
    Biome[Biome["WASTELAND"] = 8] = "WASTELAND";
    Biome[Biome["LAVA"] = 9] = "LAVA";
    Biome[Biome["CORRUPTED"] = 10] = "CORRUPTED";
    Biome[Biome["MIN"] = 1] = "MIN";
    Biome[Biome["MAX"] = 10] = "MAX";
})(Biome = exports.Biome || (exports.Biome = {}));
/**
 * list of biome names; this can be used as a mapping from biome ID numbers to
 * string names
 */
exports.BiomeNames = [
    'Unknown',
    'Ocean',
    'Forest',
    'Grassland',
    'Tundra',
    'Swamp',
    'Desert',
    'Ice',
    'Wasteland',
    'Lava',
    'Corrupted',
];
/**
 * list of artifact type names; this can be used as a mapping from artifact type
 * ID numbers to string names
 */
exports.ArtifactNames = [
    'Unknown',
    'Monolith',
    'Colossus',
    'Spaceship',
    'Pyramid',
    'Wormhole',
    'Planetary Shield',
    'Photoid Cannon',
    'Bloom Filter',
    'Black Domain',
];
/**
 * list of artifact rarity names; this can be used as a mapping from artifact
 * rarity ID numbers to string names
 */
exports.RarityNames = ['Unknown', 'Common', 'Rare', 'Epic', 'Legendary', 'Mythic'];
/**
 * list of planet type names; this can be used as a mapping from planet type ID
 * numbers to string names
 */
exports.PlanetTypeNames = ['Planet', 'Asteroid Field', 'Foundry', 'Spacetime Rip', 'Quasar'];
